import {OnlineWatcherProvider} from '@repo/shared/OnlineWatcher'
import {OrientationWatcher} from '@repo/shared/OrientationWatcher/OrientationWatcher'
import {ErrorBoundary} from '@repo/shared/ReactErrorBoundary'
import {ToastProvider} from '@repo/shared/Toast'
import {TrackingProvider} from '@repo/shared/Tracking/Tracking.provider'
import {EPlatform} from '@repo/shared/Tracking/Tracking.types'
import {VisualViewPortWrapper} from '@repo/shared/VisualViewPortWrapper/VisualViewPortWrapper'
import {WakeLockProvider} from '@repo/shared/WakeLockProvider'
import {Provider} from 'jotai'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {App} from './domains/App/App'
import {AudioProvider} from './domains/AudioProvider/AudioProvider'
import './index.css'
import jotaiStore from './utils/jotai.store'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider />
    <ErrorBoundary>
      <OnlineWatcherProvider>
        <TrackingProvider
          applicationName="coop_sprinten"
          platform={EPlatform.BIGSCREEN}
          posthogToken="phc_91gfYfPhtKkcQ3hoUrODMJGTGSdVmLqeBwYn3bl4X2U"
        >
          <Provider store={jotaiStore}>
            <WakeLockProvider>
              <OrientationWatcher supportSmPortrait supportMdPortrait supportMdLandscape>
                <AudioProvider>
                  <VisualViewPortWrapper>
                    <App />
                  </VisualViewPortWrapper>
                </AudioProvider>
              </OrientationWatcher>
            </WakeLockProvider>
          </Provider>
        </TrackingProvider>
      </OnlineWatcherProvider>
    </ErrorBoundary>
  </StrictMode>,
)
